import { defaultApiState } from '../api.state';

export const usefulLinkState = {
  apiState: {
    getUsefulLinks: defaultApiState,
    getUsefulLink: defaultApiState,
    deleteUsefulLink: defaultApiState,
    addUsefulLink: defaultApiState,
    updateUsefulLink: defaultApiState,
  },
  usefulLinks: [],
  usefulLink: undefined,
};
